import { IApplicationState } from '../../types/redux';
import { TLayoutType } from '../../types/layoutType';

export const selectLayoutType = (state: IApplicationState): TLayoutType => state.layoutType;
